import { Component, Input, OnInit } from '@angular/core';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-sidenav-custom-image',
  templateUrl: './sidenav-custom-image.component.html',
  styleUrls: ['./sidenav-custom-image.component.scss'],
  standalone: false
})
export class SidenavCustomImageComponent {

  @Input() data: any;  
  @Input() title: string;
  @Input() subtitle: string;
  formattedBody: string[] = [];
  copyFormatedJson: boolean;

constructor(private sidenavService: SidenavService, private clipboardApi: ClipboardService) {
}

 ngOnInit(): void {
      const customJsonString = JSON.stringify(this.data, null, 2);      
      this.formattedBody = customJsonString?.split('\n');
      this.copyFormatedJson = false;
 }

 /* Copies the specified text content to the clipboard */
  copyText(): void {
    let copyJson = this.formattedBody.join('\n');
    this.copyFormatedJson = true;
    this.clipboardApi.copyFromContent(copyJson);
    setTimeout(() => {
      this.copyFormatedJson = false;
    }, 5000);
  }

  /* Closes the currently opened right sidenav panel */
  closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }
  
}
